import React from "react";

const FEATURES = [
    {
        id: "tilt-detection",
        title: "Tilt Detection",
        body: "Real-time signals when your behavior drifts from your baseline. Chasing losses leaves fingerprints.",
    },
    {
        id: "parlay-risk",
        title: "Parlay Risk Audit",
        body: "Correlation, vig, and true price on every leg. Find out what the book is actually selling you.",
    },
];

function FeatureIcon() {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--tb-gold)"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M12 2v4" />
            <path d="m6.2 6.2 2.8 2.8" />
            <path d="M2 12h4" />
            <path d="m6.2 17.8 2.8-2.8" />
            <path d="M12 22v-4" />
            <path d="m17.8 17.8-2.8-2.8" />
            <path d="M22 12h-4" />
            <path d="m17.8 6.2-2.8 2.8" />
            <circle cx="12" cy="12" r="2" />
        </svg>
    );
}

export default function Features() {
    return (
        <section
            id="features"
            data-testid="features-section"
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 mb-16">
                    <div>
                        <span
                            data-testid="features-eyebrow"
                            className="tb-overline mb-5 block"
                        >
                            The Audit Stack
                        </span>
                        <h2
                            data-testid="features-title"
                            className="tb-h2 text-3xl md:text-4xl lg:text-5xl max-w-xl"
                        >
                            Two checks. Every ticket. Before you press place.
                        </h2>
                    </div>
                    <p className="text-[var(--tb-text-body)] text-base md:text-lg max-w-md leading-relaxed">
                        Tiltbox isn't another tracker. It's a structured
                        pre-flight protocol — built so the decision happens
                        before the adrenaline does.
                    </p>
                </div>

                <div
                    data-testid="features-grid"
                    className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6"
                >
                    {FEATURES.map((f, i) => (
                        <article
                            key={f.id}
                            data-testid={`feature-${f.id}`}
                            className="tb-feature tb-reveal"
                            style={{ animationDelay: `${80 + i * 70}ms` }}
                        >
                            <div className="flex items-center justify-between mb-6">
                                <div
                                    className="w-11 h-11 rounded-xl flex items-center justify-center"
                                    style={{
                                        background:
                                            "rgba(197, 160, 89, 0.08)",
                                        border:
                                            "1px solid rgba(197, 160, 89, 0.18)",
                                    }}
                                >
                                    <FeatureIcon />
                                </div>
                                <span className="font-display text-[11px] tracking-[0.28em] uppercase text-[var(--tb-text-dim)]">
                                    0{i + 1}
                                </span>
                            </div>
                            <h3
                                className="font-display text-white text-[22px] md:text-[24px] font-bold mb-3 tracking-tight"
                                data-testid={`feature-${f.id}-title`}
                            >
                                {f.title}
                            </h3>
                            <p
                                className="text-[var(--tb-text-body)] text-[15px] leading-relaxed"
                                data-testid={`feature-${f.id}-body`}
                            >
                                {f.body}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
